import React from "react";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Routes, useNavigate, useParams } from "react-router-dom";
import PdfLoaderModal from "../pdfloader";
import {
  getOneApplicationDetail,
  getOnePanelApplicationDetail,
  submitEnclosureFiles,
} from "../../auth/services/privateapicalling";
// import SingleDocumentView from "../pdfloader/Singleview";
import SingleView from "../pdfloader/Singleview";
import RectificationOnResjection from "./RectificationOnRejection";
import useCommonServices from "../../../hooks/useCommonServices";
import PanelLicenseDownload from "./PanelLicenseDownload";
import ApplicationPreview from "./DownloadApplication";

interface ApplicationDetails {
  applicantName: string;

  partnershipFirm: string;
}
interface DocumentDetail {
  docId: string;
  documentName: string;
  fileName: string;
}
interface ApplicationDetails {
  departmentId: string;
  applicantName: string;
  isPartner: string;
  panCardNo: string;
  yrOfExpAsBusErr?: number;
  regEmailId: string;
  mobileNo: string;
  representatives: any[];
  firmRepresentatives: any[];
  guarantorDetails: any[];
  applicationId: string;
  createdAt: string;
  docs: any[];
  status: string;
  paymentStatus: string;
  itReturnDetail: DocumentDetail[];
  declarationDetail: DocumentDetail;
  departmentSelectType:string;
  borderDepartmentIdentifier: any;
  department: any;
  panelEnginnerAppTransaction:any[]
  structuralDetail:any;
}

interface AddressData {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeDetails {
  DOB: string;
  registeredEmail: string;
  mobileNo: string;
}
interface Education {
  id: number;
  docId?: string;
  standard: string;
  specialization: string;
  documentName: string;
  fileName?: string;
}
interface Experience {
  id: number;
  projectName: string;
  projectAwardedby: string;
  eveidenceProof?: {
    docId: string;
    documentName: string;
    fileName: string;
  }; // Define structure properly
  startDate: string;
  endDate: string;
}
interface WorkPerformed {
  id: number;
  projectName: string;
  projectAwardedby: string;
  eveidenceProof?: {
    docId: string;
    documentName: string;
    fileName: string;
  }; // Optional attachment URL
  startDate: string;
  endDate: string;
}
interface ConstructionDetail {
  id: number;
  projectName: string;
  projectAwardedby: string;
  eveidenceProof?: {
    docId: string;
    documentName: string;
    fileName: string;
  }; // Optional attachment URL
  startDate: string;
  endDate: string;
}
interface Partner {
  id: number;
  name: string;
  partnerAge: number; // Updated property name
  address: string;
}

const PanelPreview: React.FC = () => {
  const [application, setApplication] = useState<ApplicationDetails | null>(
    null
  );
  const [downloadapplication, setDownloadApplication] = useState<any[] | null>(
    null
  );
  const [partners, setPartner] = useState<Partner[]>([]);
  const [addressData, setAddressData] = useState<AddressData | null>(null);
  // const [userAddress, setUserAddress] = useState<UserAddress | null>(null);
  const [officeAddress, setOfficeAddress] = useState<OfficeAddress | null>(
    null
  );
  const [officeDetails, setOfficeDetails] = useState<OfficeDetails | null>(
    null
  );
  const [docs, setDocs] = useState<any[]>([]);

  const { downloadLicense } = useCommonServices();

  const roleIdentifier = useSelector(
    (state: any) => state.auth.userDetails?.Role?.Role_Identifier
  );

  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  const [education, setEducation] = useState<Education[]>([]);
  const [experience, setExperience] = useState<Experience[]>([]);
  const [workPerformed, setWorkPerformed] = useState<WorkPerformed[]>([]);
  const [constructionDetails, setConstructionDetails] = useState<
    ConstructionDetail[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const [role, setRole] = useState<string>("");
  const [buttonData, setButtonData] = useState<any[]>([]);
  const [transaction, setTransaction] = useState<any[]>([]);
  const [rejectedDocs, setRejectedDocs] = useState<any[]>([]);
  const [rejectedFields, setRejectedFields] = useState<any[]>([]);

  const token = useSelector((state: any) => state.auth.token);
  const [showPreview, setShowPreview] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>(
    {}
  );
  const educationLevelMap = {
    highSchool: 'High School ',
    diploma: 'Diploma ',
    bachelorDegree: 'Bachelor Degree ',
    mastersDegree: 'Masters Degree ',
    phd: 'Ph.D.',
  };
  const professionMap = {
    civilEngineer: ' Civil Engineer',
    architect: ' Architect',
    constructionEngineer: 'Construction Engineer',
    billingServiceEngineer: 'Billing Service Engineer',
  };
  const language = useSelector((state: any) => state.auth.language);
  const { applicationId } = useParams<{ applicationId: string }>();

  const navigate = useNavigate();

  const handleDraftApplication = () => {
    navigate("/license");
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
     
    }
  };

  const fetchApplicationDetails = async (appId: any) => {
    try {
      //.log("fff")
      //.log('apppidddd',appId)
      const data = await getOnePanelApplicationDetail(appId, token);
  
      if (!data?.success) {
        navigate("/error-404");
      }
      setApplication(data.data);
      setDocs(data.data?.docs);

      setPartner(
        data.data.partnerDetails.map((partner: any) => ({
          name: partner.partnerName || "N/A",
          partnerAge: partner.partnerAge || "N/A",
          address: partner.partnerAddress || "N/A",
        }))
      );

      setAddressData({
        address: data.data.perAddress.at || "N/A",
        post: data.data.perAddress.post || "N/A",
        taluka: data.data.perAddress.taluka || "N/A",
        district: data.data.perAddress.district || "N/A",
      });

      setOfficeAddress({
        address: data.data.regOffAddress.at || "N/A",
        post: data.data.regOffAddress.post || "N/A",
        taluka: data.data.regOffAddress.taluka || "N/A",
        district: data.data.regOffAddress.district || "N/A",
      });

      setOfficeDetails({
        DOB: data.data.dob || "N/A",
        registeredEmail: data.data.regEmailId || "N/A",
        mobileNo: data.data.mobileNo || "N/A",
      });

      setEducation(data.data.eduQualification || []);
      setExperience(data.data.experienceDetail || []);
      setWorkPerformed(data.data.govSemiGovExpDetail || []);
      setConstructionDetails(data.data.marketPublicConstructionDetail || []); //  const testdocID = "67cc7b9f5ce5a960d78030a3";
      //  const docData = await getDocument(testdocID ,token)
      //  //.log('docccc' , docData);

      setApplication(data.data);
      setDownloadApplication(data.data);

      setButtonData(data.data.buttonName);
      setRole(data.data?.role);

      const application = data?.data;

      const rejectedDocs = application?.rejectedDocName;
      const rejectedFields = application?.rejectedFieldName;
      //.log('resubrejjjj fields docs', rejectedFields, rejectedDocs)
      setRejectedDocs(rejectedDocs);
      setRejectedFields(rejectedFields);
      //.log('rejecteddd docss and fields',rejectedDocs , rejectedFields)

      //  const app = data.data;
      //  const curradd = app.currAddress;
      //  //.log('ccc',curradd)
      //  setAddressData(curradd)
    } catch (err) {
      setError("Failed to load application details");
    } finally {
      setLoading(false);
      //.log("apppp" ,application)
    }
  };
  let itArray: any[];
  let testArray = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const augustFirst = new Date(currentYear, 7, 1); // August = month 7 (0-based)

    // If today is before August 1, current FY is not included
    const endYear = today < augustFirst ? currentYear - 1 : currentYear;

    const fiscalYears = [];

    for (let i = 2; i >= 0; i--) {
      const start = endYear - i;
      const end = start - 1;
      fiscalYears.push(`FY ${end}-${start}`);
    }
    itArray = fiscalYears;
    return fiscalYears;
  };

  useEffect(()=>{
    testArray()
  },[])

 
  useEffect(() => {
    //.log("pppppppppp")

    //.log('param id' , applicationId)

    fetchApplicationDetails(applicationId);
    // fetchTraderApplicationButton();
  }, []);

  return (
    <>
      <div>
        <div className="cardhead page-wrapper">
          <div className="container-fluid content">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">
                    {language.panel_engineer_preview}{" "}
                  </h3>
                  {/* <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="active breadcrumb-item">Horizontal Form</li>
                  </ul> */}
                </div>

                {application && application.status == "approve" && (
                  <div className="col-sm-12 ">
                    {/* <button onClick={()=>{handleDownload()}}
                      className="bg-success rounded text-white px-4 py-2"
                    >
                      Download License
                    </button> */}
                    {/* <PanelLicenseDownload
                      application={application}
                      partners={partners}
                      officeAddress={officeAddress}
                    /> */}
                    {docs
                      .filter((doc) =>
                        doc.documentName.toLowerCase().includes("license")
                      )
                      .map((doc) => (
                        <Link
                          key={doc.docId}
                          to="#"
                          data-bs-toggle="modal"
                          data-inert={true}
                          data-bs-target="#single_modal"
                          className="btn btn-primary align-items-center"
                          onClick={() => setSelectedDocId(doc.docId)}
                        >
                          {language.download_license}
                        </Link>
                      ))}
                  </div>
                )}

                {application &&
                  application?.status == "resubmission" &&
                  roleIdentifier === "Per" &&
                  applicationId &&
                  token &&
                  buttonData && (
                    <div className="mb-4 mt-4">
                      <RectificationOnResjection
                        docs={docs}
                        rejectedDocs={rejectedDocs}
                        rejectedFields={rejectedFields}
                        applicationId={applicationId}
                        token={token}
                        buttonData={buttonData}
                        education={education}
                        applicationTransaction={application?.panelEnginnerAppTransaction}
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">{language.app_details}</h5>
                  </div>
                  <div className="card-body">
                    {loading ? (
                      <p>Loading application details...</p>
                    ) : error ? (
                      <p className="text-danger">{error}</p>
                    ) : (
                      <div className="table-responsive">
                        {/* First Table */}
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>{language.applicant_name}</th>

                              <th>{language.partnership_firm}</th>
                              <th>{language.district}</th>
                              <th>{application?.departmentSelectType === "entireState"
                                  ? "Entire State"
                                  : language.borderDistrict}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {application ? (
                              <tr>
                                <td>{application.applicantName}</td>

                                <td>
                                  {application?.isPartner == "true"
                                    ? "Yes"
                                    : "No"}
                                </td>
                                <td>{application?.department?.District}</td>
                                <td style={{ whiteSpace: "normal" }}>
                                  {application?.departmentSelectType === "entireState"
                                    ? "Entire State(Gujarat)"
                                    : application?.borderDepartmentIdentifier
                                        ?.length
                                    ? application.borderDepartmentIdentifier
                                        .map((data) => data.District)
                                        .join(", ")
                                    : "N/A"}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No application details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* Second Table */}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div>
                      <h5 className="mb-2 px-4 py-2">
                        {language.partner_details}:
                      </h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.name}</th>
                                <th>{language.age_in_year}</th>
                                <th>{language.address}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : partners.length > 0 ? (
                                partners.map((partner, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td>{partner?.name || "N/A"}</td>
                                    <td>{partner?.partnerAge || "N/A"}</td>
                                    <td>{partner?.address || "N/A"}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No Partners available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div>
                        <h5 className="mb-2">{language.full_address}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      padding: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {language.address}
                                  </th>
                                  <th>{language.post}</th>
                                  <th>{language.taluka}</th>
                                  <th>{language.district}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : addressData ? (
                                  <tr>
                                    <td>{addressData.address}</td>
                                    <td>{addressData.post}</td>
                                    <td>{addressData.taluka}</td>
                                    <td>{addressData.district}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No address details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <h5 className="mb-2">
                          {language.registered_office_address}:
                        </h5>

                        {/* Office Address Table */}
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      padding: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {language.address}
                                  </th>
                                  <th>{language.post}</th>
                                  <th>{language.taluka}</th>
                                  <th>{language.district}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : officeAddress ? (
                                  <tr>
                                    <td>{officeAddress.address}</td>
                                    <td>{officeAddress.post}</td>
                                    <td>{officeAddress.taluka}</td>
                                    <td>{officeAddress.district}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No office address details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Office Details Table */}
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>{language.registered_email_id}</th>
                                  <th>{language.mobile}</th>
                                  <th>{language.DOB}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : officeDetails ? (
                                  <tr>
                                    <td>{officeDetails.registeredEmail}</td>
                                    <td>{officeDetails.mobileNo}</td>
                                    <td>{officeDetails.DOB}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No office details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <h5 className="mb-2">{language.education_details}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.education}</th>
                                <th>{language.specialization}</th>
                                <th>{language.attachement}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : education.length > 0 ? (
                                education.map((edu, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td>{educationLevelMap[edu.standard] || edu.standard}</td>

                                    <td>
                                      {edu.specialization
                                        ? professionMap[edu.specialization] || edu.specialization
                                        : "N/A"}
                                    </td>
                                    <td>
                                      {edu.fileName ? (
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-inert={true}
                                          data-bs-target="#single_modal"
                                          className="btn btn-primary align-items-center"
                                          onClick={() =>
                                            setSelectedDocId(edu.docId)
                                          }
                                        >
                                          {language.preview}
                                        </Link>
                                      ) : (
                                        "No Attachment"
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No education records available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {
                        application && application?.structuralDetail && Object.keys(application?.structuralDetail).length > 0 && 
                        <>
                      <h5 className="mb-2">{language.structuralDetail}:</h5>
                        <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#single_modal"
                            className=" btn btn-primary align-items-center mb-4"
                            onClick={() =>
                              setSelectedDocId(
                                application?.structuralDetail.docId
                              )
                            }
                          >
                            {language.preview}
                          </Link>
                        
                        </>
                        
                      }
                        {
                        application && application?.docs.find(item=>item?.documentName==="otherDoc")  && 
                        <>
                      <h5 className="mb-2">{language.otherDoc}:</h5>
                        <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#single_modal"
                            className=" btn btn-primary align-items-center mb-4"
                            onClick={() =>
                              setSelectedDocId(
                               application?.docs.find(item=>item?.documentName==="otherDoc")?.docId
                              )
                            }
                          >
                            {language.preview}
                          </Link>
                        
                        </>
                        
                      }
                      <div>
                        <h5 className="mb-2">{language.experience_details}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>{language.project_name}</th>
                                  <th>{language.project_awarded_by}</th>
                                  <th>{language.attachements}</th>
                                  <th>{language.start_date}</th>
                                  <th>{language.end_date}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : experience.length > 0 ? (
                                  experience.map((exp, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{exp.projectName}</td>
                                      <td>{exp.projectAwardedby}</td>
                                      <td>
                                        {exp?.eveidenceProof?.fileName ? (
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#single_modal"
                                            className=" btn btn-primary align-items-center "
                                            onClick={() =>
                                              setSelectedDocId(
                                                exp?.eveidenceProof?.docId
                                              )
                                            }
                                          >
                                            {language.preview}
                                          </Link>
                                        ) : (
                                          "No Attachment"
                                        )}
                                      </td>
                                      <td>{exp.startDate}</td>
                                      <td>{exp.endDate}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No experience records available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 m-2">
                        <h5>{language.business_engineer}</h5>
                        <p>
                          <strong>
                            {application?.yrOfExpAsBusErr ?? "Not provided"}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <h5 className="mb-2">{language.work_performed}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>{language.project_name}</th>
                                  <th>{language.project_awarded_by}</th>
                                  <th>{language.attachements}</th>
                                  <th>{language.start_date}</th>
                                  <th>{language.end_date}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : workPerformed.length > 0 ? (
                                  workPerformed.map((work, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{work.projectName}</td>
                                      <td>{work.projectAwardedby}</td>
                                      <td>
                                        {work?.eveidenceProof?.fileName ? (
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#single_modal"
                                            className=" btn btn-primary align-items-center "
                                            onClick={() =>
                                              setSelectedDocId(
                                                work?.eveidenceProof?.docId
                                              )
                                            }
                                          >
                                            {language.preview}
                                          </Link>
                                        ) : (
                                          "No Attachment"
                                        )}
                                      </td>
                                      <td>{work.startDate}</td>
                                      <td>{work.endDate}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No work performed records available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-2">{language.done_construction}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>{language.project_name}</th>
                                  <th>{language.project_awarded_by}</th>
                                  <th>{language.attachements}</th>
                                  <th>{language.start_date}</th>
                                  <th>{language.end_date}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : constructionDetails.length > 0 ? (
                                  constructionDetails.map((detail, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{detail.projectName}</td>
                                      <td>{detail.projectAwardedby}</td>
                                      <td>
                                        {detail?.eveidenceProof?.fileName ? (
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#single_modal"
                                            className=" btn btn-primary align-items-center"
                                            onClick={() =>
                                              setSelectedDocId(
                                                detail?.eveidenceProof?.docId
                                              )
                                            }
                                          >
                                            {language.preview}
                                          </Link>
                                        ) : (
                                          "No Attachment"
                                        )}
                                      </td>
                                      <td>{detail.startDate}</td>
                                      <td>{detail.endDate}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No construction records available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="row d-flex align-items-center">
                        <div className="col-md-6">
                          <h5 className="mb-2">{language.it_returns}</h5>
                          <div className="card-body">
                            <div className="table-responsive">
                              {application?.itReturnDetail?.length > 0 ? (
                                application?.itReturnDetail?.map(
                                  (item, index) => (
                                    <div key={index} className="mb-2">
                                      <Link
                                        to="#"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#single_modal"
                                        className="btn btn-primary align-items-center"
                                        onClick={() =>
                                          setSelectedDocId(item?.docId)
                                        }
                                      >
                                        {language.preview} -{" "}
                                        {"IT Returns Document-" +
                                          item?.documentName?.split("_")[1] }
                                          
                                      </Link>
                                      <span className="ms-2">
                                        {item?.fileName}
                                      </span>
                                    </div>
                                  )
                                )
                              ) : (
                                <div>No Attachment</div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-md-6">
                          <h5 className="mb-2">
                            {language.applicant_declaration}
                          </h5>
                          <div className="card-body">
                            <div className="table-responsive">
                              {application?.declarationDetail?.docId ? (
                                <Link
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-inert={true}
                                  data-bs-target="#single_modal"
                                  className="btn btn-primary align-items-center"
                                  onClick={() =>
                                    setSelectedDocId(
                                      application?.declarationDetail?.docId
                                    )
                                  }
                                >
                                  {language.preview}
                                </Link>
                              ) : (
                                "No Attachment"
                              )}
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    {application && application.status == "draft" && (
                      <div className="d-flex justify-content-between p-4 w-50">
                        <button
                          className="btn btn-success"
                          onClick={handleDraftApplication}
                        >
                          {language.complete}
                        </button>
                      </div>
                    )}
                    <div className="d-flex justify-content-between p-4 w-50">
                      {/* <button className="btn btn-success" onClick={handleApplicationPreview}>
      Download Application
      </button> */}
                      {}

                      <div className="d-flex justify-content-between p-4 w-50">
                        {/* Conditionally render file input if roleIdentifier is "Dr" */}

                        <ApplicationPreview
                          downloadapplication={downloadapplication}
                        />
                      </div>

                      {/* Show preview only when `showPreview` is true */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {applicationId ? (
          <>
            <PdfLoaderModal
              applicationId={applicationId}
              applicationType="panel"
            />
            <SingleView docId={selectedDocId} />
          </>
        ) : (
          <p className="text-danger">Application ID is missing.</p>
        )}
      </div>
    </>
  );
};

export default PanelPreview;
